import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class LiabilityWriteUpFlexiReportCriteria extends Model.CriteriaBase {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    @Rules.Required()
    public signatory1: number | null = null;

    @Rules.Required()
    public signatory2: number | null = null;

    @Rules.Required()
    public signatory3: number | null = null;

    // Client only properties / methods

    public signatoryName1: number | null = null;

    public signatoryName2: number | null = null;

    public signatoryName3: number | null = null;

    protected static addBusinessRules(rules: Validation.Rules<LiabilityWriteUpFlexiReportCriteria>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.startDate !== null && c.endDate !== null && c.startDate >= c.endDate, "The end date must be on or after the start date.").onProperties(c => [c.startDate, c.endDate]);
    }

    public toString(): string {
        return "Liability Writeup Flexi Report Criteria";
    }
}